import { queryOptions, useQuery } from '@tanstack/react-query';
import { ensureOBSMinVersion } from '../utils/ensureOBSPresence';
import { Box, Text } from '@streamelements/frontend-ui';
import { PropsWithChildren } from 'react';
import { KeyboardArrowRightRounded } from '@streamelements/frontend-icons';

const seLiveVersionQueryOptions = ({ minVersion }: { minVersion: number[] }) =>
  queryOptions({
    queryKey: ['selive-version'],
    queryFn: () => ensureOBSMinVersion({ minVersion }),
  });

export function UnsupportedOBSVersion({ minVersion, children }: PropsWithChildren<{ minVersion?: number[] }>) {
  const { data: { seLiveVersion } = { seLiveVersion: 'Loading...' } } = useQuery(
    seLiveVersionQueryOptions({ minVersion: minVersion || [] })
  );

  return (
    <Box
      css={{
        size: '100%',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
      }}
    >
      <Text.Subtitle weight="bold">Unsupported SE.Live Version</Text.Subtitle>

      <Text.Body css={{ color: '$textPrimary50', px: '2rem', mb: '1rem' }}>
        Please update your copy of the SE.Live plugin to the latest version.
      </Text.Body>

      <Text.Body css={{ color: '$textPrimary50', px: '2rem', mb: '1rem' }}>
        StreamElements menu{' '}
        <Box
          as={KeyboardArrowRightRounded}
          css={{ verticalAlign: 'middle', mt: '-0.125rem' }}
          style={{ fontSize: '1.125rem' }}
        />{' '}
        Check for Updates
      </Text.Body>

      <Text.Body css={{ color: '$textPrimary50' }}>Installed version: {seLiveVersion}</Text.Body>
      {minVersion ? (
        <Text.Body css={{ color: '$textPrimary50', mb: '1rem' }}>
          Minimum required version: {minVersion.join('.')}
        </Text.Body>
      ) : null}

      {children}
    </Box>
  );
}
